/*
 * BIRDLOVER — theme the Shopify Forms email popup to match the glass theme.
 * The Forms app renders inside an OPEN shadow DOM, so ordinary theme CSS can't
 * reach it. This injects brand styles into each <shopify-forms-embed> shadow
 * root using STABLE selectors (data-testid + tags + JS-applied data hooks)
 * rather than the app's hashed class names, so it survives app updates.
 */
(function () {
  var CSS = [
    /* Dimmed backdrop behind the modal */
    '[data-bl-backdrop]{background:rgba(6,10,22,.72)!important;-webkit-backdrop-filter:blur(4px)!important;backdrop-filter:blur(4px)!important;}',
    /* Glass modal card */
    '[data-bl-card]{background:linear-gradient(160deg,rgba(16,26,56,.94),rgba(10,15,30,.96))!important;border:1px solid rgba(56,232,198,.28)!important;border-radius:20px!important;box-shadow:0 24px 70px rgba(0,0,0,.55),0 0 40px rgba(56,232,198,.12),inset 0 1px 0 rgba(255,255,255,.06)!important;-webkit-backdrop-filter:blur(18px)!important;backdrop-filter:blur(18px)!important;overflow:hidden!important;}',
    '[data-bl-card] *{font-family:var(--font-body-family,"Montserrat",sans-serif)!important;}',
    '[data-bl-card] h1,[data-bl-card] h2,[data-bl-card] h3{color:#fff!important;font-family:var(--font-heading-family,"Montserrat",sans-serif)!important;font-weight:800!important;letter-spacing:.2px!important;}',
    '[data-bl-card] p,[data-bl-card] label,[data-bl-card] span{color:rgba(255,255,255,.72)!important;}',
    '[data-bl-card] a{color:#38e8c6!important;text-decoration:underline!important;}',
    /* Inputs */
    '[data-bl-card] input{background:rgba(255,255,255,.07)!important;border:1px solid rgba(255,255,255,.16)!important;border-radius:12px!important;color:#fff!important;}',
    '[data-bl-card] input::placeholder{color:rgba(255,255,255,.5)!important;}',
    '[data-bl-card] input:focus{border-color:#38e8c6!important;box-shadow:0 0 0 3px rgba(56,232,198,.22)!important;outline:none!important;background:rgba(255,255,255,.10)!important;}',
    /* Primary submit button — brand teal gradient pill */
    '[data-testid="btn-form-submit"]{background:linear-gradient(135deg,#4f7cff 0%,#38e8c6 100%)!important;color:#06131a!important;font-family:var(--font-heading-family,"Montserrat",sans-serif)!important;font-weight:800!important;border:0!important;border-radius:40px!important;box-shadow:0 10px 26px rgba(56,232,198,.30)!important;transition:transform .15s ease,box-shadow .15s ease,filter .15s ease!important;cursor:pointer!important;}',
    '[data-testid="btn-form-submit"]:hover{transform:translateY(-2px)!important;filter:brightness(1.05)!important;box-shadow:0 16px 34px rgba(56,232,198,.42)!important;}',
    /* Close icon */
    '[data-bl-card] svg{color:rgba(255,255,255,.85)!important;}',
    /* Collapsed teaser tab */
    '[data-testid="form-teaser"]{background:linear-gradient(135deg,#4f7cff,#38e8c6)!important;border:0!important;border-radius:16px!important;box-shadow:0 12px 30px rgba(56,232,198,.30)!important;}',
    '[data-testid="form-teaser"] h1,[data-testid="form-teaser"] h2,[data-testid="form-teaser"] h3,[data-testid="form-teaser"] span{color:#06131a!important;font-weight:800!important;}'
  ].join('\n');

  // Tag the modal card + backdrop with stable hooks (card = a <section> whose
  // parent is also a <section>; backdrop = its sibling <div>).
  function tag(root) {
    var card = null, sections = root.querySelectorAll('section');
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].parentElement && sections[i].parentElement.tagName === 'SECTION') { card = sections[i]; break; }
    }
    if (card) {
      card.setAttribute('data-bl-card', '');
      var kids = card.parentElement.children;
      for (var j = 0; j < kids.length; j++) {
        if (kids[j] !== card && kids[j].tagName === 'DIV') kids[j].setAttribute('data-bl-backdrop', '');
      }
    }
  }

  function inject(root) {
    if (!root) return;
    if (!root.querySelector('style[data-bl-forms]')) {
      var s = document.createElement('style');
      s.setAttribute('data-bl-forms', '');
      s.textContent = CSS;
      root.appendChild(s);
    }
    // Watch the shadow root itself so teaser -> modal re-renders get re-tagged
    // (light-DOM observers can't see mutations inside a shadow root).
    if (!root.__blObserved) {
      root.__blObserved = true;
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    }
    tag(root);
  }

  function scan() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < hosts.length; i++) { if (hosts[i].shadowRoot) inject(hosts[i].shadowRoot); }
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(scan, 60); }

  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
